export default "__VITE_ASSET__CMYfYpRk__"